import { useEffect } from "react";
import { centralMonitorData, stopAutoRefresh } from "../Actions/CentralMonitoringScreenAction";
import MapModal from "../Component/MapModal/MapModal";
import ListView from "../Component/ListView/ListView";

export const tabs = [
  { id: "mapView", label: "Map View", Component: MapModal },
  { id: "listView", label: "List View", Component: ListView },
];

export const useAutoRefresh = (dispatch) => {
  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(centralMonitorData());
    }, process.env.REACT_APP_DASHBOARD_REFRESH_INTERVAL);

    return () => {
      clearInterval(interval);
      dispatch(stopAutoRefresh());
    };
  }, [dispatch]);
};

export const handleStatusClick = (hoveredMarkerId, dispatch, navigate) => {
  dispatch(stopAutoRefresh());
  navigate(`/healthStatus/${hoveredMarkerId}`);
};

export const handleKeyDown = (e, index, tabs, setActiveTab, tabRefs) => {
  const lastIndex = tabs.length - 1;
  let newIndex = index;

  switch (e.key) {
    case "ArrowRight":
      newIndex = index === lastIndex ? 0 : index + 1;
      break;
    case "ArrowLeft":
      newIndex = index === 0 ? lastIndex : index - 1;
      break;
    case "Home":
      newIndex = 0;
      break;
    case "End":
      newIndex = lastIndex;
      break;
    default:
      return;
  }

  e.preventDefault();
  setActiveTab(tabs[newIndex].id);
  tabRefs.current[newIndex]?.focus();
};

export const focusFirstTab = (tabRefs) => {
  tabRefs.current[0]?.focus();
};
